export default "__VITE_ASSET__ada6b4bb__"